export default __webpack_public_path__ + "assets/images/8ffccceeb312380ca9568cf09538851f.svg";